import { StatisticThresholdExceedanceDataItem, ThresholdCrossingTimesItem } from "../../models/types/statistic";
import { useLookupParameter } from "../../utils/get-lookup";
import dayjs from "dayjs";

type TableProps = {
    staticData: StatisticThresholdExceedanceDataItem[];
    selectDay?: string;
    numberOfTimes?: number;
    loading?: boolean;
}
const StatisticTable = ({ staticData, selectDay, numberOfTimes, loading }: TableProps) => {
    const { lookupParameter } = useLookupParameter();
    // Tìm số lần vượt ngưỡng lớn nhất
    const maxThresholdTimes = numberOfTimes || 0;

    return (
        <table className="max-h-full w-full statistic-table text-sm bg-[repeating-linear-gradient(45deg,_#c5c5c5_0_10px,_#fff_10px_20px)]">
            <thead className="sticky top-[-1px] z-1">
                <tr className="">
                    <th className="px-2 py-1" rowSpan={2}>Trạm quan trắc</th>
                    <th className="px-2 py-1" rowSpan={2}>Thông số</th>
                    <th className="px-2 py-1" rowSpan={2}>Giá trị giới hạn</th>
                    <th className="px-2 py-1 min-w-[120px]" colSpan={2}>Số liệu {selectDay}</th>

                    {Array.from({ length: maxThresholdTimes }).map((_, idx) => (
                        <th className="px-2 py-1" key={"vuot_" + idx} colSpan={2}>
                            Vượt ngưỡng lần {idx + 1}
                        </th>
                    ))}
                </tr>
                <tr>
                    <th className="px-2 py-1 min-w-[60px]">Giá trị trung bình</th>
                    <th className="px-2 py-1">Giá trị lớn nhất</th>
                    {Array.from({ length: maxThresholdTimes }).map((_, idx) => [
                        <th className="px-2 py-1" key={`tgps_${idx}`}>Thời điểm phát sinh</th>,
                        <th className="px-2 py-1 min-w-[50px]" key={`tgxl_${idx}`}>Thời gian xử lý</th>
                    ])}
                </tr>
            </thead>
            <tbody className="bg-white">
                {loading ? (
                    <tr>
                        <td colSpan={6} className="text-center py-4">
                            <div className="flex items-center justify-center">
                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-900"></div>
                            </div>
                        </td>
                    </tr>
                ) : staticData?.length === 0 ? (
                    <tr>
                        <td colSpan={6} className="text-center py-4">
                            <div className="flex items-center justify-center">
                                <div className="text-gray-500">Chưa có dữ liệu</div>
                            </div>
                        </td>
                    </tr>
                ) : staticData?.map((item: StatisticThresholdExceedanceDataItem, idx: number) => {
                    const unit = lookupParameter.find((p: any) => p.id === item.parameterId)?.unitName;
                    return (
                        <tr key={idx} className="border-b border-gray-300">
                            <td className="px-2 py-1 !text-left">{item.stationName}</td>
                            <td className="px-2 py-1 !text-left">{item.parameterName + (unit ? ` (${unit})` : ' (-)')}</td>
                            <td className="px-2 py-1">{item.limit ? item.limit : "-"}</td>
                            <td className="px-2 py-1">{item.avg ? item.avg : "-"}</td>
                            <td className="px-2 py-1">{item.max ? item.max : "-"}</td>
                            {item.thresholdCrossingTimes?.map((thresholdCrossingTime: ThresholdCrossingTimesItem, idx: number) => (
                                <>
                                    <td className="px-2 py-1">{thresholdCrossingTime.occurrenceTime ? dayjs(thresholdCrossingTime.occurrenceTime).format('DD/MM/YYYY HH:mm') : "-"}</td>
                                    <td className="px-2 py-1">
                                        {typeof thresholdCrossingTime.processingTime === 'number'
                                            ? (() => {
                                                const totalMinutes = Math.round(thresholdCrossingTime.processingTime * 60);
                                                const hours = Math.floor(totalMinutes / 60);
                                                const minutes = totalMinutes % 60;
                                                return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                                            })()
                                            : "-"}
                                    </td>
                                </>
                            ))}
                        </tr>
                    )
                })}
            </tbody>
        </table>
    )
}

export default StatisticTable;
